import React, { useState, useEffect } from 'react';
import {Link, useNavigate} from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import './PolicyPage.css'


export default function PolicyPage() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const error = useSelector(state => state.auth.error);
    
    return(
       
      <div className='PolicyPage'>
            <h1>Контент</h1>
      </div>


    )
}